module.exports = __webpack_public_path__ + "static/media/zoo.c50889e3.jpg";